import { useContext } from 'react';
import { AuthContext } from '../services/authContext';
import { Navigate } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import '../scss/components/appStats.scss';

//Components
//import ChatHistoryReport from '../components/modules/reports/ChatHistory';
import AppUsersReport from '../components/modules/reports/AppUsers';
import UserDemographicsReport from '../components/modules/reports/UserDemographics';

const AppStatistics = () => {

    const { isLoggedIn, userProfile, userRoles } = useContext(AuthContext);

    if (!isLoggedIn || !userProfile) {
        return <Navigate to="/" />;
    }

    return (
        <div id="AppStats" className="screen">
            <Row>
                <Col xs={12} md={6}>
                    <AppUsersReport />
                </Col>
                <Col xs={12} md={6}>
                    <UserDemographicsReport />
                </Col>
                {(userRoles.includes('Admin') || userRoles.includes('Service Lead')) && (
                    <Col xs={12} md={6}>
                        {/*<ChatHistoryReport />*/}
                    </Col>
                )}
            </Row>


        </div>
    );
};

export default AppStatistics;
